import { i18n } from '@lingui/core';
import { t } from '@lingui/macro';
import classnames from 'classnames';
import { connect } from 'react-redux';
import React, { Fragment } from 'react';
import { ReactComponent as CircleLegend } from '../../../assets/images/circle.svg';
import { onChangeIsochronesFilter2 } from '../../../ac/onChangeMapFilters';
import { isochronesWithScootersFilterValues } from '../../../constants/variables';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import styles from '../FilterSidebar.module.css';

const IsochronesWithScootersComponent = ({
    mapFilters,
    onChangeIsochronesFilter2,
}) => (
    <div>
        <div className={styles.checkboxIconGrid}>
            {
                isochronesWithScootersFilterValues.map(({ value, fill, label }) => (
                    <Fragment key={value}>
                        <CircleLegend
                            fill={fill}
                            width='2vw'
                            height='2vw'
                            opacity='0.8'
                        />
                        <label htmlFor={label.id}>{i18n._(label)}</label>
                        <div>
                            <label className={styles.switch}>
                                <input
                                    type='checkbox'
                                    name='poi'
                                    id={value}
                                    checked={mapFilters.isochronesWithScootersFilterStatuses.includes(value)}
                                    value={value}
                                    onChange={onChangeIsochronesFilter2}
                                />
                                <span className={classnames(styles.sliderRound, styles.slider)} />
                            </label>
                        </div>
                    </Fragment>
                ))
            }
        </div>
        <div style={{ padding: '10px' }}>
            <small>{t`Изохроны с самокатами отображаются только для парковок с хотя бы 2 самокатами за последние 15 минут`}</small>
        </div>
    </div>
);
const mapStateToProps = ({ mapFilters }) => ({ mapFilters });
const ConnectedComponent = connect(mapStateToProps, { onChangeIsochronesFilter2 })(IsochronesWithScootersComponent);
export const IsoParkingsWithScootersFilter = withDisplayedLayersCheck(ConnectedComponent, t`Изохроны доступности парковок`);
